import { FC } from 'react'

type DefaultProps = Pick<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'onBlur' | 'checked' | 'disabled'>

export type ToggleSwitchProps = DefaultProps & {
  isDisabled?: boolean
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({ isDisabled, ...props }) => {
  return (
    <label className=" form-check form-switch form-check-custom form-check-solid">
      <input
        {...props}
        disabled={isDisabled}
        type="checkbox"
        className="form-check-input force-transition"
        autoComplete="off"
      />
    </label>
  )
}
